var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdgeDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u91C7\u96C6\u8BBE\u5907\u6570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-280.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u91C7\\u96C6\\u8BBE\\u5907\\u6570",
    transform: "translate(280.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4558547,2.03506575 L6.10519724,2.03506575 C5.54237437,2.03506575 5.08766437,2.48977575 5.08766437,3.05259862 L5.08766437,10.1753287 L27.4733876,10.1753287 L27.4733876,3.05259862 C27.4733876,2.48977575 27.0186776,2.03506575 26.4558547,2.03506575 Z M9.15779587,7.37711334 C8.45506223,7.37711334 7.88587977,6.80793089 7.88587977,6.10519724 C7.88587977,5.4024636 8.45506223,4.83328115 9.15779587,4.83328115 C9.86052951,4.83328115 10.429712,5.4024636 10.429712,6.10519724 C10.429712,6.80793089 9.86052951,7.37711334 9.15779587,7.37711334 Z M5.08766437,29.5084534 C5.08766437,30.0712762 5.54237437,30.5259862 6.10519724,30.5259862 L26.4558547,30.5259862 C27.0186776,30.5259862 27.4733876,30.0712762 27.4733876,29.5084534 L27.4733876,22.3857232 L5.08766437,22.3857232 L5.08766437,29.5084534 Z M9.15779587,25.1839386 C9.86052951,25.1839386 10.429712,25.7531211 10.429712,26.4558547 C10.429712,27.1585884 9.86052951,27.7277708 9.15779587,27.7277708 C8.45506223,27.7277708 7.88587977,27.1585884 7.88587977,26.4558547 C7.88587977,25.7531211 8.45506223,25.1839386 9.15779587,25.1839386 Z M5.08766437,20.3506575 L27.4733876,20.3506575 L27.4733876,12.2103945 L5.08766437,12.2103945 L5.08766437,20.3506575 Z M9.15779587,15.0086099 C9.86052951,15.0086099 10.429712,15.5777923 10.429712,16.280526 C10.429712,16.9832596 9.86052951,17.5524421 9.15779587,17.5524421 C8.45506223,17.5524421 7.88587977,16.9832596 7.88587977,16.280526 C7.88587977,15.5777923 8.45506223,15.0086099 9.15779587,15.0086099 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeDevice);
export default __webpack_public_path__ + "static/media/edgeDevice.0d7d12a52de2acb92044ff25025a52b8.svg";
export { ForwardRef as ReactComponent };